module.exports = "pegasus/assets/blocks/column-lp12-basic.png";